import { ReactPortal } from "../../../components/reactPortal"
import { Modal } from "../../../components/modal/modal"
import { useSelector, useDispatch } from "../../../hooks/redux"
import { CustomButton } from "../../../components/customButton"
import classes from "../../../styles/admin/adminModal.module.scss"
import ttsClasses from "../../../styles/tts/ttsModal.module.scss"
import ttsSidebarClasses from "../../../styles/tts/ttsSidebar.module.scss"
import { setModalVisibility, updateModalSettings, updateSelectedUsersList } from "../../../store/slices/admin/adminSlice"
import { deleteUser } from "../../../store/slices/user/async"
import cn from "classnames"
import { UserSettings } from "../users/userSettings"


export const DeleteUserModal = () => {
  const dispatch = useDispatch()
  const modalType = useSelector((state) => state.admin.modal.type)
  const show = modalType === 'delete' || modalType === 'deleteSelected'
  const config = useSelector((state) => state.admin.modal.user)
  const auth_token = useSelector((state) => state.user.user.auth_token)
  const selectedUsers = useSelector((state) => state.admin.selectedUsers)
  const users = useSelector((state) => state.user.users)
  const isDeleteSelected = modalType === 'deleteSelected'

  const handleCloseModal = () => {
    dispatch(setModalVisibility('none'))
    dispatch(updateModalSettings({
      auth_username: '',
      auth_token: '',
      access_console: false,
      access_asr: false,
      access_tts: false,
      access_admin: false
    }))
  }

  const removeUser = () => {
    try {
      if (isDeleteSelected) {
        selectedUsers.forEach(user_id => {
          dispatch(deleteUser({ auth_token, user_id }))
        })
        selectedUsers.forEach(user_id => dispatch(updateSelectedUsersList(user_id)))
      } else {
        dispatch(deleteUser({ auth_token, user_id: config.user_id }))
        if (config.user_id && selectedUsers.includes(config.user_id)) {
          dispatch(updateSelectedUsersList(config.user_id))
        }
      }
      // const {
      //   auth_token: token,
      //   auth_username: name,
      //   ...rest
      // } = modal.user;

      // const data = {
      //   token,
      //   name,
      //   auth_token,
      //   ...rest
      // }

      // const res = dispatch(deleteUser(data))
      handleCloseModal()

      // return res
    } catch (e) {
      // dispatch(addNotify({ text: `Не удалось добавить пользователя (${e})` }))
    }
  }

  return (
    <ReactPortal>
      <Modal
        classes={{ modalContent: cn(ttsClasses.ttsModal, ttsClasses.TtsModalSettings) }}
        title={isDeleteSelected ? `Удаление пользователей (${selectedUsers.length})` : 'Удаление пользователя'}
        subtitle={isDeleteSelected ? 'Вы уверены, что хотите удалить выбранных пользователей?' : 'Вы уверены, что хотите удалить пользователя?'}
        isOpen={show}
        handleClose={handleCloseModal}
      >
        <div className={ttsClasses.ttsModalContent}>
          {!isDeleteSelected && (
            <UserSettings
              classes={{
                userInfo: classes.newUserInfo,
                userAccesses: classes.modalUserAccesses
              }}
              config={config}
              disabled />
          )}
          <div className={ttsClasses.ttsModalButtonGroup}>
            <CustomButton onClick={handleCloseModal}>Отмена</CustomButton>
            <CustomButton
              viewType='primary'
              className={classes.confirmationModalDeleteBtn}
              onClick={removeUser}
            >
              Удалить
            </CustomButton>
          </div>
        </div>
      </Modal>
    </ReactPortal>
  )
}
